import {useDebugValue} from 'react';

import {DEFAULT_FIELD_AUTO_PROGRESS_TYPE} from '../../../utils/field';

import {runSearchFormColourContrastAndLabelsExperiment, runCollapsedSearchformCTAExperiment} from '../../../utils/experiments';

import {useOptions} from './useOptions';

const defaultFormOptions = {
    allowErrorHighlighting: false,
    allowSummary: false,
    autoProgress: DEFAULT_FIELD_AUTO_PROGRESS_TYPE,
    autoSubmit: true,
    isColourContrastAndLabels: false,
    layout: 'standard',
    align: 'center',
    showIcons: true,
    showGuestsDetailsInputField: true,
    showSubmitDetailsButtonField: true,
    isCollapsedSearchformCTA: false
};

function useFormOptions(props, abacusStore) {
    const {
        formOptions: propsFormOptions
    } = props;

    const showColorContrastExperiment = runSearchFormColourContrastAndLabelsExperiment({shouldLogExperiment: true}, abacusStore) || false;
    const showCollapsedSearchformCTAExperiment = runCollapsedSearchformCTAExperiment({shouldLogExperiment: true}, abacusStore) || false;

    const experimentFormOptions = {
        isColourContrastAndLabels: showColorContrastExperiment,
        isCollapsedSearchformCTA: showCollapsedSearchformCTAExperiment
    };

    const {
        options: formOptions
    } = useOptions(defaultFormOptions, experimentFormOptions, propsFormOptions);

    const result = {
        formOptions
    };

    useDebugValue(result);

    return result;
}

export {useFormOptions};
